import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { FormHelperText } from 'base-ui'

import {
  FEATURE_TOGGLE_SELLER_CENTRAL,
  useFeatureToggle,
} from '../../../../feature-toggles'
import { BrandsProviderType } from '../../../marketplacePartnerRegisterPageMakeFormState'
import { useMarketplacePartnerRegisterPageContext } from '../../marketplacePartnerRegisterPageContext'

import { MarketplacePartnerRegisterPageFormBrandsAdder } from './MarketplacePartnerRegisterPageFormBrandsAdder'
import { MarketplacePartnerRegisterPageFormBrandsAutocomplete } from './MarketplacePartnerRegisterPageFormBrandsAutocomplete'
import { MarketplacePartnerRegisterPageFormBrandsEstimatedRevenue } from './MarketplacePartnerRegisterPageFormBrandsEstimatedRevenue'
import { MarketplacePartnerRegisterPageFormBrandsProductsCount } from './MarketplacePartnerRegisterPageFormBrandsProductsCount'
import { MarketplacePartnerRegisterPageFormBrandsProviderTypeSelection } from './MarketplacePartnerRegisterPageFormBrandsProviderTypeSelection'
import { MarketplacePartnerRegisterPageFormBrandsRevenueShare } from './MarketplacePartnerRegisterPageFormBrandsRevenueShare'
import { MarketplacePartnerRegisterPageFormBrandTextArea } from './MarketplacePartnerRegisterPageFormBrandTextArea'

export const MarketplacePartnerRegisterPageFormBrands: FC = () => {
  const { formState } = useMarketplacePartnerRegisterPageContext()
  formState.use()
  const providerType = formState.model.brandsProviderType

  return (
    <div className="flex flex-col gap-10">
      {useFeatureToggle(FEATURE_TOGGLE_SELLER_CENTRAL) ? (
        <>
          <MarketplacePartnerRegisterPageFormBrandsProviderTypeSelection />
          <div className="flex flex-col gap-4 text-l">
            <FormattedMessage id="marketplacePartnerRegisterPage.brands.description" />

            {providerType === BrandsProviderType.DROPDOWN ? (
              <MarketplacePartnerRegisterPageFormBrandsAutocomplete />
            ) : (
              <MarketplacePartnerRegisterPageFormBrandTextArea />
            )}
          </div>
        </>
      ) : (
        <MarketplacePartnerRegisterPageFormBrandsAdder />
      )}
      {formState.model.validator.getFirstErrorFor('brands') && (
        <FormHelperText data-qa-id="global-MessageForm-brands-error-msg" error>
          {formState.model.validator.getFirstErrorFor('brands')}
        </FormHelperText>
      )}

      <MarketplacePartnerRegisterPageFormBrandsProductsCount />
      <MarketplacePartnerRegisterPageFormBrandsEstimatedRevenue />
      <MarketplacePartnerRegisterPageFormBrandsRevenueShare />
    </div>
  )
}
